import { render, staticRenderFns } from "./AModal.vue?vue&type=template&id=13883900&scoped=true"
import script from "./AModal.vue?vue&type=script&lang=js"
export * from "./AModal.vue?vue&type=script&lang=js"
import style0 from "./AModal.vue?vue&type=style&index=0&id=13883900&prod&lang=scss"
import style1 from "./AModal.vue?vue&type=style&index=1&id=13883900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13883900",
  null
  
)

export default component.exports